import IconButton from '@material-ui/core/IconButton';
import VideogameAssetIcon from '@material-ui/icons/VideogameAsset';
import React from 'react';

export const ShowPlayAGame = ({onPlay}) => {
	return (
		<div>
			<IconButton aria-label="play a game" onClick={onPlay}>
				<VideogameAssetIcon />
			</IconButton>
		</div>
	)
}
